import { ResponseMESF } from "@dexteel/mesf-core";
import { Box, Divider, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useEAFDataEntryActions } from "../../../hooks/useEAFDataEntryActions";
import { readPhasesFromPLC } from "../../../repositories/eaf.repositories";
import { AgGridFooterActions } from "../components/AgGridFooterActions";
import { useEAFDETablesStyles } from "../styles/useEAFDETablesStyles";
import { useTableData } from "./hooks/usePhasesTableData";

export const TablePhases = () => {
	const {
		state: { deProcess, isProcessTimesLoading },
		actions: { setNotificationMessage, setErrorMessage },
	} = useDataEntryContext();
	const { refreshData } = useEAFDataEntryActions();

	const phases = deProcess?.phases;
	const rowCount = phases ? phases.length : 0;

	const classes = useEAFDETablesStyles({ rowCount });
	const readFromPLC = async () => {
		const ProcessId = deProcess?.process?.ProcessId;

		if (ProcessId) {
			const resp = await readPhasesFromPLC({ ProcessId });
			if (resp.ok) {
				await refreshData();
			} else {
				setErrorMessage(resp.message);
			}
			return resp;
		} else {
			setNotificationMessage("Process not found");
			return { ok: false, message: "Process not found" } as ResponseMESF;
		}
	};

	const { columns } = useTableData();

	return (
		<>
			<Paper elevation={0}>
				<Box padding={1} className={`${classes.phasesAgGridBox}`}>
					<AgGridReact
						rowSelection="single"
						suppressRowClickSelection={true}
						pagination={false}
						singleClickEdit={false}
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						rowData={phases}
						columnDefs={columns}
						domLayout="normal"
						suppressContextMenu={true}
						loading={isProcessTimesLoading}
					/>
					<Divider />
					<AgGridFooterActions
						hasMaxItems={false}
						readFromPLC={readFromPLC}
						table="phases"
					/>
				</Box>
			</Paper>
		</>
	);
};
